import type { SxProps, Theme } from '@mui/material/styles';

export const getDialogSx = (drawerOpen: boolean | undefined): SxProps<Theme> => ({
  position: 'absolute',
  right: drawerOpen ? '20rem' : 0,
  '.MuiBackdrop-root': {
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.3)',
    backdropFilter: 'blur(4px)',
  },
  '& .MuiPaper-root': {
    padding: '1rem',
    maxWidth: '100%',
    minHeight: '70vh',
    height: window.innerHeight > 1000 ? '95vh' : 'calc(100vh - 15rem)',
    maxHeight: window.innerHeight > 1000 ? '95vh' : 'calc(100vh - 15rem)',
    display: 'flex',
    flexDirection: 'column',
  },
});

export const dialogContentSx: SxProps<Theme> = {
  padding: '0',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'visible',
  flex: 1,
  minHeight: 0,
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
};

export const tableContainerSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
};

export const predefinedFiltersWrapperSx: SxProps<Theme> = {
  mb: 2,
};

export const dialogActionsSx: SxProps<Theme> = {
  padding: 0,
  mt: 2,
};

interface DataGridSxParams {
  fillHeight: boolean;
  height: number | string | 'fill' | 'auto' | undefined;
  radioSelection: boolean | undefined;
  hasRowGrouping: boolean;
  consumerSx: object | undefined;
}

export const buildDataGridSx = ({
  fillHeight,
  height,
  radioSelection,
  hasRowGrouping,
  consumerSx,
}: DataGridSxParams): SxProps<Theme> => ({
  flex: fillHeight ? 1 : undefined,
  minHeight: fillHeight ? 0 : undefined,
  ...(hasRowGrouping ? { '--DataGrid-cellOffsetMultiplier': 6 } : undefined),
  '& .MuiDataGrid-virtualScroller': {
    overflowX: 'auto',
    overflowY: height === 'auto' ? 'visible' : 'auto',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    position: 'relative',
  },
  ...(radioSelection && {
    '& .MuiDataGrid-columnHeaderCheckbox': {
      pointerEvents: 'none',
      '& *': { visibility: 'hidden' },
    },
    '& .GeneratikTable-groupRow .MuiDataGrid-cellCheckbox': {
      pointerEvents: 'none',
      '& *': { visibility: 'hidden' },
    },
  }),
  ...consumerSx,
});
